import { history, useLocation, useModel } from '@umijs/max';
import { Button, Result } from 'antd';
import React, { useSyncExternalStore } from 'react';
import {
  getActivityProcessEntrySnapshot,
  loadActivityProcessEntry,
  subscribeActivityProcessEntry,
} from '@/utils/activityProcessEntry';
import { hasAuthSession } from '@/utils/authSession';
import {
  getPermissionRecoveryState,
  subscribePermissionRecovery,
} from '@/utils/mockPermissions';
import ActivityProcessEntrySync from './ActivityProcessEntrySync';
import AuthSessionRecoverySync from './AuthSessionRecoverySync';
import PermissionRecoveryResult from './PermissionRecoveryResult';

/** The layout's access guard does not mount childrenRender or the workflow page. */
export default function ActivityProcessAccessFallback() {
  const { pathname } = useLocation();
  const permission = useSyncExternalStore(
    subscribePermissionRecovery,
    getPermissionRecoveryState,
    getPermissionRecoveryState,
  );
  const recovering =
    hasAuthSession() &&
    permission.status !== 'ready' &&
    permission.status !== 'denied';
  const { initialState } = useModel('@@initialState');
  const entry = useSyncExternalStore(
    subscribeActivityProcessEntry,
    getActivityProcessEntrySnapshot,
    getActivityProcessEntrySnapshot,
  );
  const isProcessEntry = [
    '/',
    '/activity-center',
    '/activity-center/activity-workflow',
  ].includes(pathname);
  const canRetry =
    isProcessEntry &&
    Boolean(entry.ownerId) &&
    initialState?.currentUser?.id === entry.ownerId &&
    entry.status !== 'ready' &&
    !entry.denied;
  const loading = entry.status === 'idle' || entry.status === 'loading';
  const processContent = canRetry ? (
    <Result
      status="warning"
      title={loading ? '正在确认流程入口资格' : '流程入口查询失败'}
      subTitle="入口资格尚未确认，请重新查询后进入活动流程。"
      extra={
        <Button
          type="primary"
          loading={loading}
          onClick={() => {
            loadActivityProcessEntry({ force: true }).catch(() => undefined);
          }}
        >
          重新查询入口
        </Button>
      }
    />
  ) : (
    <Result
      status="403"
      title="403"
      subTitle="抱歉，你无权访问该页面"
      extra={
        <Button type="primary" onClick={() => history.push('/')}>
          返回首页
        </Button>
      }
    />
  );
  return (
    <>
      <AuthSessionRecoverySync />
      <ActivityProcessEntrySync />
      {recovering ? <PermissionRecoveryResult /> : processContent}
    </>
  );
}
